import * as dateFns from 'date-fns';

export default function dateRangeFormatter(dates) {
  const { startDate, endDate } = dates;

  const haveCurrentYear = dateFns.isThisYear(startDate) && dateFns.isThisYear(endDate);
  const haveSameYear = dateFns.isSameYear(startDate, endDate);
  const haveSameMonth = dateFns.isSameMonth(startDate, endDate);
  const haveSameDay = dateFns.isSameDay(startDate, endDate);

  let dateRange;
  switch (true) {
    case haveCurrentYear && haveSameDay:
      dateRange = dateFns.format(startDate, 'MMM d');
      break;
    case haveCurrentYear && haveSameMonth:
      dateRange = `${dateFns.format(startDate, 'MMM d')} - ${dateFns.format(endDate, 'd')}`;
      break;
    case haveCurrentYear:
      dateRange = `${dateFns.format(startDate, 'MMM d')} - ${dateFns.format(endDate, 'MMM d')}`;
      break;
    case haveSameDay:
      dateRange = dateFns.format(startDate, 'MMM d, yyyy');
      break;
    case haveSameYear && haveSameMonth:
      dateRange = `${dateFns.format(startDate, 'MMM d')} - ${dateFns.format(endDate, 'd, yyyy')}`;
      break;
    case haveSameYear:
      dateRange = `${dateFns.format(startDate, 'MMM d')} - ${dateFns.format(endDate, 'MMM d, yyyy')}`;
      break;
    default:
      dateRange = `${dateFns.format(startDate, 'MMM d, yyyy')} - ${dateFns.format(endDate, 'MMM d, yyyy')}`;
  };
  return dateRange;
};


// WEBPACK FOOTER //
// ./app/javascript/app/utils/dateRangeFormatter.js